/**
 * Global sale lock: when the theme countdown ends, block add-to-cart + checkout
 * via UI disable, form submit capture, and fetch interception.
 */
(function () {
  function getEndUTC(dateStr, timeStr, tz) {
    if (!dateStr) return null;
    var parts = String(dateStr).split('-');
    if (parts.length < 3) return null;
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10) - 1;
    var d = parseInt(parts[2], 10);
    var timeParts = String(timeStr || '23:59').split(':');
    var h = parseInt(timeParts[0], 10);
    var min = parseInt(timeParts[1], 10) || 0;
    if (isNaN(y) || isNaN(m) || isNaN(d) || isNaN(h)) return null;
    var utc = Date.UTC(y, m, d, h, min);
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz || 'UTC',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
      var formatted = formatter.formatToParts(new Date(utc));
      var get = function (name) {
        var p = formatted.find(function (x) {
          return x.type === name;
        });
        return p ? parseInt(p.value, 10) : 0;
      };
      var fH = get('hour');
      var fMin = get('minute');
      utc += (h - fH) * 3600000 + (min - fMin) * 60000;
    } catch (e) {}
    return new Date(utc);
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = String(url);
      if (path.indexOf('http') === 0) {
        path = new URL(path, window.location.origin).pathname;
      }
      return /\/cart\/add/.test(path);
    } catch (e) {
      return String(url).indexOf('/cart/add') !== -1;
    }
  }

  function setButtonLocked(btn, label) {
    if (!btn || btn.getAttribute('data-sale-lock-ui') === '1') return;
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('data-sale-lock-ui', '1');
    var span = btn.querySelector('span:not(.sold-out-message):not(.loading__spinner):not(.icon-wrap)');
    if (span && !span.classList.contains('svg-wrapper')) {
      span.textContent = label;
    }
  }

  var SaleLock = {
    enabled: false,
    ended: false,
    endUtc: null,
    message: 'Venta finalizada',
    buttonLabel: 'Venta finalizada',
    blockCheckout: true,
    _interval: null,
    _applying: false,
    _observer: null,
    _eventFired: false,
    _raf: null,

    isEnded: function () {
      if (!this.enabled) return false;
      if (this.ended) return true;
      if (this.endUtc && Date.now() >= this.endUtc.getTime()) {
        this.ended = true;
        return true;
      }
      return false;
    },

    lockProductForm: function (formEl) {
      if (!formEl || formEl.getAttribute('data-sale-lock-locked') === 'true') {
        if (formEl) {
          formEl
            .querySelectorAll(
              'button[type="submit"], button[name="add"], .product-form__submit, .quick-add__submit'
            )
            .forEach(function (btn) {
              setButtonLocked(btn, SaleLock.buttonLabel);
            });
        }
        return;
      }
      formEl.setAttribute('data-sale-lock-locked', 'true');
      formEl.classList.add('sale-lock-locked');
      var variantInput = formEl.querySelector('input[name="id"]');
      if (variantInput) variantInput.disabled = true;
      formEl
        .querySelectorAll(
          'button[type="submit"], button[name="add"], .product-form__submit, .quick-add__submit'
        )
        .forEach(function (btn) {
          setButtonLocked(btn, SaleLock.buttonLabel);
        });
    },

    apply: function () {
      if (!this.isEnded() || this._applying) return;
      this._applying = true;

      if (this._observer) this._observer.disconnect();

      try {
        document.documentElement.classList.add('sale-lock-ended');
        if (document.body) document.body.classList.add('sale-lock-ended');

        document.querySelectorAll('product-form').forEach(function (el) {
          SaleLock.lockProductForm(el);
        });

        document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
          SaleLock.lockProductForm(form.closest('product-form') || form);
        });

        document
          .querySelectorAll('.quick-add__submit, button[name="add"], .product-form__submit')
          .forEach(function (btn) {
            setButtonLocked(btn, SaleLock.buttonLabel);
          });

        document.querySelectorAll('.shopify-payment-button, .payment-button').forEach(function (el) {
          if (el.getAttribute('data-sale-lock-ui') === '1') return;
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.5';
          el.setAttribute('aria-disabled', 'true');
          el.setAttribute('data-sale-lock-ui', '1');
        });

        if (this.blockCheckout) {
          document
            .querySelectorAll('[name="checkout"], .cart__checkout-button, [data-consent-terms-checkout]')
            .forEach(function (btn) {
              setButtonLocked(btn, SaleLock.buttonLabel);
            });
        }

        if (!this._eventFired) {
          this._eventFired = true;
          document.dispatchEvent(new CustomEvent('sale-lock:ended', { detail: { message: this.message } }));
        }
      } finally {
        this._applying = false;
        if (this._observer && document.documentElement) {
          this._observer.observe(document.documentElement, { childList: true, subtree: true });
        }
      }
    },

    scheduleApply: function () {
      if (!this.isEnded() || this._applying || this._raf) return;
      var self = this;
      this._raf = requestAnimationFrame(function () {
        self._raf = null;
        self.apply();
      });
    },

    init: function (config) {
      config = config || window.saleLockConfig || {};
      this.enabled = !!config.enabled;
      this.message = config.message || this.message;
      this.buttonLabel = config.buttonLabel || this.buttonLabel;
      this.blockCheckout = config.blockCheckout !== false;
      this.ended = !!config.ended;
      this.endUtc = getEndUTC(config.date, config.time, config.timezone);

      if (!this.enabled) return;

      if (this.isEnded()) {
        this.apply();
      } else if (this.endUtc) {
        var self = this;
        this._interval = setInterval(function () {
          if (self.isEnded()) {
            clearInterval(self._interval);
            self._interval = null;
            self.apply();
          }
        }, 1000);
      }

      document.addEventListener(
        'submit',
        function (evt) {
          if (!SaleLock.isEnded()) return;
          var form = evt.target;
          if (!form || form.tagName !== 'FORM') return;
          var isAdd =
            form.getAttribute('data-type') === 'add-to-cart-form' ||
            !!form.querySelector('[name="add"]') ||
            (form.action && isCartAddUrl(form.action));
          var isCheckout =
            SaleLock.blockCheckout &&
            (!!form.querySelector('[name="checkout"]') ||
              (evt.submitter && evt.submitter.getAttribute('name') === 'checkout'));
          if (isAdd || isCheckout) {
            evt.preventDefault();
            evt.stopPropagation();
          }
        },
        true
      );

      if (typeof window.fetch === 'function') {
        var originalFetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : input && input.url;
          if (SaleLock.isEnded() && isCartAddUrl(url)) {
            return Promise.resolve(
              new Response(
                JSON.stringify({
                  status: 422,
                  message: SaleLock.message,
                  description: SaleLock.message,
                  errors: SaleLock.message,
                }),
                { status: 422, headers: { 'Content-Type': 'application/json' } }
              )
            );
          }
          return originalFetch(input, init);
        };
      }

      if (typeof MutationObserver !== 'undefined') {
        this._observer = new MutationObserver(function (mutations) {
          if (!SaleLock.isEnded() || SaleLock._applying) return;
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
              SaleLock.scheduleApply();
              return;
            }
          }
        });
        if (document.documentElement) {
          this._observer.observe(document.documentElement, { childList: true, subtree: true });
        }
      }
    },
  };

  window.SaleLock = SaleLock;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      SaleLock.init(window.saleLockConfig);
    });
  } else {
    SaleLock.init(window.saleLockConfig);
  }
})();
